import { Component, OnInit } from '@angular/core';
import { map, switchMap } from "rxjs/operators";
import { Companies, SingleCompany } from "../../../_shared/interfaces";
import { AlertService, ContactsStoreService, IAlertType } from "../../../_shared/services";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ClrIconModule } from "@clr/angular";
import { ContactFormComponent } from "../contact-form/contact-form.component";
import { NgIf } from "@angular/common";
import { getTenantStorage } from '../../../_shared/utils/tenant-context';

import { environment as env } from "../../../../environments/environment";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

@Component({
  selector: 'app-contact-update',
  standalone: true,
  imports: [
    RouterLink,
    ClrIconModule,
    ContactFormComponent,
    NgIf
  ],
  templateUrl: './contact-update.component.html',
  styleUrl: './contact-update.component.sass'
})
export class ContactUpdateComponent implements OnInit {
  devMode: boolean;
  crmMode: boolean;
  company: SingleCompany | null = null;

  constructor(
    private css: ContactsStoreService,
    private router: Router,
    private route: ActivatedRoute,
    private alertDispatcher: AlertService
  ) {
    this.devMode = env.stages.dev;
    this.crmMode = env.externalCrm;
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit() {
    this.route.paramMap.pipe(
      map(params => parseInt(params.get('cid') ?? '0', 10)),
      switchMap((cid: number) => this.css.getSingleCompany(cid))
    )
      .subscribe(res => this.company = res.object?.[0] ?? null);
  }

  updateCompany(company: Companies) {
    this.css.updateCompany(company)
      .subscribe(() => {
        this.alertDispatcher.alertConfig.message = 'Kontakt ' + company.cid + ' wurde aktualisiert!';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;

        if (!this.crmMode) {
          this.router.navigate([`contact/details/${company.cid}`]);
          return;
        }

        const sessionId = getTenantStorage('crm_token') ?? '';
        const staffId = parseInt(getTenantStorage('staff_id') ?? getTenantStorage('user_id') ?? '0', 10);
        if (!sessionId || !staffId) {
          this.alertDispatcher.show({
            message: 'Kontakt gespeichert, aber CRM-Sync übersprungen (Token/Staff-ID fehlt).',
            clrAlertType: IAlertType.WARNING
          }, 3500);
          this.router.navigate([`contact/details/${company.cid}`]);
          return;
        }

        this.css.syncCrmContact(company.cid, { session_id: sessionId, staff_id: staffId }).subscribe({
          next: () => {
            this.alertDispatcher.show({
              message: 'Kontakt in PPS gespeichert und CRM-Sync ausgeführt.',
              clrAlertType: IAlertType.SUCCESS
            }, 2500);
          },
          error: () => {
            this.alertDispatcher.show({
              message: 'Kontakt gespeichert, CRM-Sync fehlgeschlagen.',
              clrAlertType: IAlertType.WARNING
            }, 4000);
          },
          complete: () => {
            this.router.navigate([`contact/details/${company.cid}`]);
          }
        });
      });
  }
}
